module.exports = __webpack_public_path__ + "static/cola-5c373e61f7b203eae3c3410dd15cef87.jpg";